/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext } from 'react';
import PropTypes from 'prop-types';

import { Button, Heading, ModalContext } from 'school-space-client/components';

import { openRecurringStartEndDatesModal } from '../../recurringBooking/modals';

import RecurringBookingSummary from '../../recurringBooking/RecurringBookingSummary';
import css from './css';

const ReviewStartEndDates = ({
    recurringBooking,
    confirmStep,
    stepIsConfirmed,
    refetchBooking
}) => {
    const modalProps = useContext(ModalContext);

    const changeDates = () =>
        openRecurringStartEndDatesModal({
            ...modalProps,
            recurringBooking,
            refetchBooking
        });

    return (
        <div>
            {!stepIsConfirmed && (
                <Heading level="2" size="medium" styles={css.heading}>
                    1. Review start and end dates
                </Heading>
            )}
            <div css={css.content}>
                <RecurringBookingSummary recurringBooking={recurringBooking} />
                <div css={css.actionButtons}>
                    <Button
                        state="ghost"
                        styles={css.actionButton}
                        size="small"
                        onClick={changeDates}
                    >
                        Change dates
                    </Button>
                    {!stepIsConfirmed && (
                        <Button styles={css.actionButton} size="small" onClick={confirmStep}>
                            Confirm dates
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

ReviewStartEndDates.propTypes = {
    recurringBooking: PropTypes.objectOf(PropTypes.any).isRequired,
    confirmStep: PropTypes.func.isRequired,
    stepIsConfirmed: PropTypes.bool.isRequired,
    refetchBooking: PropTypes.func.isRequired
};

export default ReviewStartEndDates;
